import BlockContent from '@sanity/block-content-to-react'
import React from 'react'
import { SERIALIZERS } from '../common'
import { DATASET, PROJECT_ID } from '../layouts'

// components

export const RichContent = ({ richContent }) =>
  richContent ? <BlockContent blocks={richContent} dataset={DATASET} projectId={PROJECT_ID} serializers={SERIALIZERS} /> : null
